import templateUrl from "emun.order/retrieve-hostedpci-info.htm";
import RetrieveHostedPCIInfoController from "emun.order/retrieve-hostedpci-info.controller";
import open from "webmodals/open";

let RetrieveHostedPCIInfo = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
	  controller: RetrieveHostedPCIInfoController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default RetrieveHostedPCIInfo;
